import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {InputConfig} from "../../../../model/channels.model";

@Component({
  selector: "admin-channels-view-input",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.css"]
})
export class AdminChannelViewInputInputComponent implements OnChanges {

  @Input() input?: InputConfig;

  inputConfig: Record<string, string>[] = [];
  mappingConfig: Record<string, string>[] = [];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["input"]) {
      this.inputConfig = this.prepareInputTable();
      this.mappingConfig = this.prepareMappingTable();
    }
  }

  private prepareInputTable(): Record<string, string>[] {
    let inputSettings: Record<string, string>[] = []
    if (this.input?.settings) {
      inputSettings = Object.keys(this.input?.settings!).map((item) => {
        return {
          name: item,
          type: "settings",
          value: this.input!.settings![item]
        }
      });
    }

    return inputSettings;
  }

  private prepareMappingTable(): Record<string, string>[] {
    let mappingValues: Record<string, string>[] = []
    if (this.input?.mapping) {
      mappingValues = Object.keys(this.input?.mapping)
        .reduce((acc: Record<string, string>[], item: string) => { return acc.concat(this.mapping(item)) }, []);
    }
    return mappingValues;
  }

  private mapping(column: string) {
    let columnMapping = this.input!.mapping![column]!;
    return Object.keys(columnMapping).map((item) => {
      return {
        mapping: column,
        parameter: item,
        value: columnMapping[item]
      }
    });
  }

  hasConfig(data: Record<string, string>[]): boolean {
    return !!data && Object.keys(data).length > 0;
  }
}
